import { useQueries, useQueryClient } from "@tanstack/react-query";

import { getCalculatedPigletFootprintByYear } from "services";

import { getActiveToken, getEnvironment, shouldRetryQueryError, useGetCarbonProgramByFarmId, useUserContext } from "utils";

import { FOOTPRINTING_PIGLET_CALCULATED_FOOTPRINT } from "consts";

export const useGetFootprintingCalculatedPigletFootprints = (farmId?: string, years: number[] = [], { enabled = true } = {}) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  const { user } = useUserContext();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const token = getActiveToken();

  return useQueries({
    queries: years.map((year) => ({
      queryKey: [FOOTPRINTING_PIGLET_CALCULATED_FOOTPRINT, farmId, year, isAdmin],
      queryFn: () => getCalculatedPigletFootprintByYear(year),
      enabled: enabled && !!farmId && !!year && !!user && !!token && !!carbonProgram?.platformFeatures?.footprinting?.pork,
      queryClient,
      gcTime: 60000,
      staleTime: 0,
      retry: shouldRetryQueryError(),
    })),
  });
};
